import React, { createContext } from "react"
import { ReportSaveWithLoadedForm } from "../_layout"
import { Trip } from "@/state/trips"
import { ReportFormData } from "@/state/report"

type ReportContext = {
	report: ReportSaveWithLoadedForm
	form: ReportFormData
}
const ctx = createContext<ReportContext>(null as any)

export const ReportContextProvider: React.FCC<ReportContext> = ({
	children,
	...props
}) => {
	return <ctx.Provider value={props}>{children}</ctx.Provider>
}

export const useLoadedReportContext = () => {
	const context = React.useContext(ctx)

	if (!context) {
		throw new Error(
			"useLoadedReport must be used within a LoadedReportContextProvider"
		)
	}
	return context
}
